"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const async_storage_1 = __importDefault(require("@react-native-async-storage/async-storage"));
const Storage = async_storage_1.default;
const setItem = (key, value) => {
    // console.log("Setting storage.......", key, value);
    Storage.setItem(key, value);
    return value;
};
const getItem = (key) => {
    return Storage.getItem(key);
};
const removeItem = (key) => {
    Storage.removeItem(key);
};
const clear = () => {
    Storage.clear();
};
exports.default = {
    setItem,
    getItem,
    removeItem,
    clear,
};
